import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import UsersIcon from '@mui/icons-material/GroupRounded';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import logo from '../../utils/images/logo.png';
import { Box, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';

import './Styles.scss';
const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'space-between',
}));
const SidebarComp = ({ open, toggleSidebar }) => {
  const theme = useTheme();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user && user.role === 'ROLE_ADMIN';
  
  // Use temporary drawer on mobile (xs and sm), persistent on desktop (md+)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Close sidebar on mobile when menu item is clicked
  const handleMenuItemClick = () => {
    if (isMobile) {
      toggleSidebar();
    }
  };

  return (
    <Drawer
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
        // Full width on mobile
        ...(isMobile && {
          width: '100%',
          maxWidth: drawerWidth,
        }),
      },
    }}
    variant={isMobile ? "temporary" : "persistent"}
    anchor="left"
    open={open}
    onClose={isMobile ? toggleSidebar : undefined} // Close on backdrop click for mobile
    ModalProps={{
      keepMounted: true, // Better mobile performance
    }}
  >
      <DrawerHeader>
        <Box className="sidebarLogo"><img src={logo} alt='' className='logo-img'/></Box>
          <IconButton onClick={toggleSidebar}>
          
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
      <List>
        <ListItem component={Link} to="/report" onClick={handleMenuItemClick}>
          <ListItemButton sx={{ minHeight: { xs: '48px', sm: 'auto' } }}>
            <ListItemIcon className='menuIcon'>
              <ReceiptLongOutlinedIcon color='primary'/>
            </ListItemIcon>
            <ListItemText primary="Report" className='menuText'/>
          </ListItemButton>
        </ListItem>

        {isAdmin && (
          <ListItem component={Link} to="/users" onClick={handleMenuItemClick}>
            <ListItemButton sx={{ minHeight: { xs: '48px', sm: 'auto' } }}>
              <ListItemIcon className='menuIcon'>
                <UsersIcon color='primary'/>
              </ListItemIcon>
              <ListItemText primary="Users" className='menuText'/>
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Drawer>
  );
};

export default SidebarComp;
